<template>
  <div id="chatbot-questions">
    <section class="chatbot-spin-loader" v-if="loadingQuestions"></section>
    <div class="container my-5" v-else>
      <div class="row">
        <div class="col-lg-12">
          <h2 class="mb-3"><i class="icofont-list"></i> Perguntas</h2>
        </div>
        <div class="col-lg-12">
          <div class="accordion" role="tablist" id="accordion-chatbot">
            <b-card
              no-body
              class="mb-1"
              v-for="(item, index) in displayedQuestions"
              :key="index"
            >
              <b-card-header header-tag="header" role="tab">
                <b-button block v-b-toggle="`accordion-${index}`">
                  {{ item.pergunta }}
                  <span class="when-opened">
                    <i class="icofont-rounded-down"></i>
                  </span>
                  <span class="when-closed">
                    <i class="icofont-rounded-up"></i>
                  </span>
                </b-button>
              </b-card-header>
              <b-collapse
                :id="`accordion-${index}`"
                accordion="my-accordion"
                role="tabpanel"
              >
                <b-card-body>
                  <p><strong>Data: </strong> {{ formatDate(item.data) }}</p>
                  <strong>Resposta da IA:</strong>
                  <p v-html="marked(item.resposta_ia)"></p>
                  <strong>Categorização:</strong>
                  <br />
                  <label class="radio-inline mr-3">
                    <input
                      type="radio"
                      name="optradio"
                      v-model="selected"
                      value="1"
                    />
                    Adequado
                  </label>
                  <label class="radio-inline">
                    <input
                      type="radio"
                      name="optradio"
                      v-model="selected"
                      value="0"
                    />
                    Não adequado.
                  </label>
                  <div v-if="selected != '' && selected == 0">
                    <strong>Resposta do especialista:</strong>
                    <b-form-textarea
                      id="textarea"
                      v-model="text"
                      placeholder=""
                      rows="5"
                      max-rows=""
                    ></b-form-textarea>
                  </div>
                  <button class="btn my-4 float-right" @click="send(item.id)">
                    Salvar resposta
                    <b-spinner
                      small
                      label="Small Spinner"
                      variant="white"
                      v-if="loadingBtn"
                    ></b-spinner>
                  </button>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
        <div class="col-md-12">
          <pagination
            :page="page"
            :pages="pages"
            v-on:update:page="page = $event"
          >
          </pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { marked } from 'marked'
import Pagination from '@/components/utils/Pagination'
import utils from '@/mixins/utils.js'

export default {
  name: 'ChatbotPerguntas',
  components: {
    Pagination,
  },
  mixins: [utils],
  data() {
    return {
      loadingQuestions: false,
      loadingBtn: false,
      text: '',
      selected: '',
      options: [
        { text: 'Adequado', value: 1 },
        { text: 'Não adequado.', value: 0 },
      ],
      questions: [],
      page: 1,
      perPage: 10,
      pages: [],
    }
  },
  computed: {
    displayedQuestions() {
      this.setPages(this.questions)
      return this.paginate(this.questions)
    },
  },
  mounted() {
    this.getQuestions()
  },
  methods: {
    marked,

    /**
     * Calcula e define as páginas da listagem.
     */
    setPages(questions) {
      let numberOfPages = Math.ceil(questions.length / this.perPage)
      this.pages = []
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index)
      }
    },

    /**
     * Retorna os registros correspondentes à página atual da paginação.
     *
     * @param {Array} questions Lista completa de registros
     * @returns {Array} Subconjunto de registros correspondente à página atual
     */
    paginate(questions) {
      let page = this.page
      let perPage = this.perPage
      let from = page * perPage - perPage
      let to = page * perPage
      return questions.slice(from, to)
    },

    /**
     * Busca as perguntas
     */
    async getQuestions() {
      try {
        this.loadingQuestions = true
        const response = await this.$apiPublic.get(
          '/chatbot/unanswered-questions'
        )
        if (response) {
          this.questions = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingQuestions = false
      }
    },

    /**
     * Envia uma pergunta
     * @param {Number} id
     */
    async send(id) {
      try {
        this.loadingBtn = true
        const response = await this.$apiPublic.post('/chatbot/question', {
          id: id,
          resposta_ia_adequada: this.selected,
          resposta_especialista: this.selected == '0' ? this.text : null,
        })
        if (response.data.error == false) {
          this.$toast.success(response.data.message, '', {
            position: 'topRight',
          })
          this.text = ''
          this.selected = ''
          await this.getQuestions()
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingBtn = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#chatbot-questions {
  display: flex;
  align-items: center;
  justify-content: center;
  .chatbot-spin-loader {
    border: 8px solid #f3f3f3;
    border-radius: 50%;
    border-top: 8px solid #000;
    width: 60px;
    height: 60px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    -webkit-animation: spin 1s linear infinite;
    animation: spin 1s linear infinite;
    @-webkit-keyframes spin {
      0% {
        -webkit-transform: rotate(0deg);
      }
      100% {
        -webkit-transform: rotate(360deg);
      }
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }

  #accordion-chatbot {
    header {
      background-color: #fff;
      background-image: none;
      padding: 10px;
      button {
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.8);
        width: 100%;
        text-align: left;
        border-radius: 0;
        height: auto;
        box-shadow: none;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    .card {
      padding: 0;
      .card-body {
        padding: 20px;
        strong {
          color: rgba(0, 0, 0, 0.8);
        }
        p {
          strong {
            color: rgba(0, 0, 0, 0.8);
          }
        }
      }
    }
    .when-opened,
    .when-closed {
      float: right;
      font-size: 25px;
    }
    .collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
      display: none;
    }
  }
}
</style>
